import { useContext } from 'react'
import { RootStoreContext } from '../_stores/rootStore'
import {
    FEATURE_TARGETING_EXPERIENCE_V2,
    FEATURE_TARGETING_EXPERIENCE_V2_TEAMS,
    FEATURE_TARGETING_EXPERIENCE_V2_ROLES
} from '../features'

/**
 * Returns true when the given exercise should use the New Targeting Experience.
 * Eligibility requires the feature flag to be on AND:
 *   - The exercise's team is in the allowed teams list (REACT_APP_FEATURE_TARGETING_EXPERIENCE_V2_TEAMS)
 *   - AND the user's role is in the allowed roles list (REACT_APP_FEATURE_TARGETING_EXPERIENCE_V2_ROLES),
 *     unless that list is empty — in which case the team gate alone is sufficient.
 *
 * Role-only check (no exercise) is intentionally not supported — team must match.
 */
export default function useTargetingExperienceV2(exercise) {
    const rootStore = useContext(RootStoreContext)
    const { user } = rootStore.userStore

    if (!FEATURE_TARGETING_EXPERIENCE_V2) return false
    if (!user) return false

    const roleMatch = FEATURE_TARGETING_EXPERIENCE_V2_ROLES.length === 0
        || FEATURE_TARGETING_EXPERIENCE_V2_ROLES.includes(String(user.role))
    const teamMatch = exercise
        ? (FEATURE_TARGETING_EXPERIENCE_V2_TEAMS.length === 0 || FEATURE_TARGETING_EXPERIENCE_V2_TEAMS.includes(String(exercise.TEAM)))
        : false

    return roleMatch && teamMatch
}
